// @flow
import React from "react";

import { Translate } from "@quantum/i18n";

import {
  SelecaoCasasDecimais,
  SelecaoTipoConta,
  SelecaoVersaoConta,
  SelecaoPeriodo,
  SelecaoFormaAcumulacao,
  SelecaoToleranciaDiasValorMercado,
  SelecaoToleranciaDF,
  SelecaoAjusteDias,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarAcumulacaoMercado = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        tipoConta: edicaoMedida.tipoConta,
        versaoConta: edicaoMedida.versaoConta,
        formaAcumulacao: edicaoMedida.formaAcumulacao,
        toleranciaDF: edicaoMedida.toleranciaDF,
        toleranciaDiasValorMercado: edicaoMedida.toleranciaDiasValorMercado,
        dataBase: dataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        tipoConta: edicaoMedida.tipoConta,
        versaoConta: edicaoMedida.versaoConta,
        formaAcumulacao: edicaoMedida.formaAcumulacao,
        toleranciaDF: edicaoMedida.toleranciaDF,
        toleranciaDiasValorMercado: edicaoMedida.toleranciaDiasValorMercado,
        dataBase: dataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

export default function AcumulacaoMercado() {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida__box">
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDiasValorMercado />
          </div>
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDF />
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoTipoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVersaoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoFormaAcumulacao />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida__box">
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDiasValorMercado />
          </div>
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDF />
          </div>
          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoTipoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVersaoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoFormaAcumulacao />
            </div>
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoCasasDecimais />
      </>
    );
  }
}
